import { Loader, Center } from "@mantine/core";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "sm",
  md: "md",
  lg: "lg",
} as const;

export function LoadingSpinner({ size = "md" }: LoadingSpinnerProps) {
  return <Loader size={sizeMap[size]} color="primary" />;
}

export function PageLoader() {
  return (
    <Center mih={400}>
      <LoadingSpinner size="lg" />
    </Center>
  );
}
